import { PORTFOLIO_DATE_FORMAT_DATA } from '../../../main/modules/portfolio/constants/general'
import { portfolioEntry, portfolioTickers, validateTickers } from '../../../main/modules/portfolio/services/api'
import { PortfolioTransaction } from '../../../main/modules/portfolio/types'
import { validateEditRow } from '../../../main/modules/portfolio/utils'
import { portfolioLimitRequest } from '../../../main/services/api'
import { FormErrors, SaveToPortfolioEntry } from './types'

export const PORTFOLIO_BASE_URL = '/portfolio.ashx?pid='

export async function validateState(state: SaveToPortfolioEntry) {
  const validation = validateEditRow(state, PORTFOLIO_DATE_FORMAT_DATA, false)
  const formErrors: FormErrors = { ...validation.errors }

  if (state.portfolioId === 0 && state.portfolioName.trim().length === 0) {
    formErrors.portfolioName = true
  }

  if (state.portfolioId !== 0) {
    const limitResponse = await portfolioLimitRequest(state.portfolioId)
    if (!limitResponse || limitResponse.transactions >= limitResponse.limitTransactions) formErrors.portfolioId = true
  }

  if (!formErrors.ticker) {
    const validatedTickers = await validateTickers([state.ticker.toUpperCase()])
    formErrors.ticker = validatedTickers[0] !== true
  }

  return { isValid: !Object.values(formErrors).some(Boolean), errors: formErrors }
}

export async function submitForm(state: SaveToPortfolioEntry): Promise<{ message?: string; isSuccess: boolean }> {
  let pid = state.portfolioId

  try {
    if (!!state.portfolioName) {
      const createdPortfolioResponse = await portfolioTickers({
        tickers: state.ticker,
        portfolioName: state.portfolioName,
      })

      if (!createdPortfolioResponse) throw new Error()
      if (state.transaction === PortfolioTransaction.Watch) return { isSuccess: true }

      pid = createdPortfolioResponse.portfolioId
    }

    await portfolioEntry({ pid }, 'POST', state)
    return { isSuccess: true }
  } catch (error) {
    const result = {
      message: 'There’s been an error saving to portfolio, make sure you’re connected to the Internet and try again.',
      isSuccess: false,
    }

    if (!!error && typeof error === 'object' && 'body' in error) {
      const apiError = error as { body: { message: string } }
      result.message = apiError.body.message
    }

    return result
  }
}
